import * as actionTypes from "./actionTypes";

export const setNumGridCols = (numGridCols: number) => {
  return { type: actionTypes.SET_NUM_GRID_COLUMNS, payload: numGridCols };
};
